export let devToken = '13dd94ab87b04fda89e0c2f058a608b7'

export function isDev() {
  console.log(222222, process.env.NODE_ENV)

  return process.env.NODE_ENV == 'development'
}


export function loadDevApiConfig() {

    devToken = '9fb0d373ce4a4022ac3a119af7ab1635'
    window.global_apiConfig = {
      appKey: 'sissjs@20200918#js$$##',
      baseApiUrl: process.env.VUE_APP_BASE_API_URL||'http://localhost:2159/',
      sissCloudTokenId: 'zhizun_ddcc8477-8728-4558-9cf9-badb3289812d',
      hostname: 'b7a76fcc3502',
      hostaddresses: '*.*.64.2',
      applicationversion: ''
    }

    window.global_cookieConfig = {
      domain: '',
      path: '/',
      prefix: 'ls47',
      passportToken: 'SissCloudTokenID'
    }

    window.global_userInfo = {
      tenantId: '433123',
      tenantName: '思迅软件',
      branchId: '11361',
      branchCode: '8888',
      branchName: '总部',
      branchType: 'Z', // 门店类型：分店
      operId: '21705',
      operName: '管理员',
      productType: '74'
    }
  
}
